import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect } from 'react-router-dom';
import LogoX from './../../assets/icons/logo.png';
import Waiter from './../../assets/gif/blueCircle.gif';
import JTableUserList from './../table/JTableUserList';
import { createGlobalStyle } from 'styled-components';
import $ from 'jquery';
import axios from 'axios';
import {validateInput as _vli,validateAllUIInputs as _vlai,stringToHex} from "./validator";
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
let personalInfo={
	fname:"",
	mname:"",
	lname:"",
	gender:"",
	dob:"",
	email:"",
	phone:"",
	password:"",
	cpassword:"",
	
};

const JComponent= ({modalObject}) => {
  const [personalInfoData,setPersonalInfoData]=useState(personalInfo);
  const [newRecord,setNewRecord]=useState(null);
  const [records,setRecords]=useState([]);
  const [implAgencyList,setImplAgencyList]=useState([]);
  useEffect(()=>{
	loadImplAgencyList();
	  setTimeout(()=>{
		window["initCalander"]("dob");
	  },2000);
  },[]);
  const loadImplAgencyList=()=>{
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/get_impl_agency.php",
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		},
		data:{name:'hellominni'}
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				setImplAgencyList(response.data);
			}
			
		}).catch((response)=>{
			console.log(response);
		})
  }
  const clearForm=()=>{
	setPersonalInfoData({
		token:"",
		implementAgency:"",
		fname:"",
		mname:"",
		lname:"",
		gender:"",
		dob:"",
		uid:"",
		email:"",
		phone:"",
		password:"",
		cpassword:"",
		
	}); 
	document.getElementById("dob").value="";	
  }
  const submitForm=()=>{
	modalObject.waiting("wait for creating user",true);
	personalInfoData.token=localStorage.getItem("_lio");
	let idata=stringToHex(JSON.stringify(personalInfoData));
	$.post(API_CORE_SERVER+"/api/user/create.php","i="+idata,async function(result) {
			console.log(result);
			modalObject.waiting("",false);
			if(result.status===1){
			clearForm();
			modalObject.ok("Successfully Saved");
			} else modalObject.ok(result.msg);
	},'json')
	.fail(function(response) {
		modalObject.waiting("",false);
		if(response.status===404) modalObject.ok("Post URL not found!");
		else modalObject.ok("Some critical ui8-issue");
	});
	
  }
  
  
  
  
return(
	<>
	<div className='row'>
					<div className='col-md-8'>
						<h5 style={{color:'#80808a',fontWeight:450}}><i className='bi bi-boxes'></i> User Information</h5>
						<div className='row'>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select className="form-select jform-control" id="implementAgency" 
									value={personalInfoData.implementAgency} 
									placeholder="Enter implementing agency" 
									onChange={async(e)=>{
										setPersonalInfoData((prev)=>{
											return {...prev,implementAgency:e.target.value}});
										}} 
									onBlur={(e)=>_vli(e)} check='mixed' minLen='1'>
									<option value=""></option>
									{
										implAgencyList.map((option,index)=>{
										 return(
											<option value={option.implAgencyId}>{option.implAgencyName}</option>
										);		
										})
									}	
									</select>	
									<label>Implementing Agency</label>
								</div>
							</div>
						</div>
						<div className='row'>	
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="fname" value={personalInfoData.fname} placeholder="Enter first name" onChange={async(e)=>{setPersonalInfoData((prev)=>{return {...prev,fname:e.target.value}});}} onBlur={(e)=>_vli(e)} check='textonly' minLen='3' maxLength='30'/>
									<label>First Name</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="mname" value={personalInfoData.mname} placeholder="Enter middle name" onChange={e=>{setPersonalInfoData((prev)=>{return {...prev,mname:e.target.value}});}} onBlur={(e)=>_vli(e)} check='optional'  maxLength='30'/>
									<label>Middle Name</label>
								</div>
							</div>
							<div className='col'>	
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="lname" value={personalInfoData.lname} placeholder="Enter last name" onChange={e=>{setPersonalInfoData((prev)=>{return {...prev,lname:e.target.value}});}} onBlur={(e)=>_vli(e)} check='textonly' minLen='3' maxLength='30'/>
									<label>Last Name</label>
								</div>
							</div>	
						</div>
						<div className='row'>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select type="select" className="form-select jform-select" id="gender" value={personalInfoData.gender} placeholder="Enter gender" onChange={e=>{setPersonalInfoData((prev)=>{return {...prev,gender:e.target.value}});}} onBlur={(e)=>_vli(e)} check='textonly' minLen='4' maxLength='30'>
									<option value=""></option>
									<option value="Male">Male</option>
									<option value="Female">Female</option>
									<option value="Transgender">Transgender</option>
									
									</select>
									<label>Gender</label>
								</div>
							</div>
							<div className='col'>		
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="dob"  autocomplete="off" placeholder="Enter dob"   onBlur={(e)=>_vli(e)} check='optional'  maxLength='10'/>
									<label>D.O.B</label>
								</div>
							</div>
							
						</div>	
						
						<div>&nbsp;</div>
						<h5 style={{color:'#80808a',fontWeight:450}}><i className='bi bi-boxes'></i> User Credential</h5>					
						<div className='row'>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="email" value={personalInfoData.email}  placeholder="Enter email" onChange={e=>{setPersonalInfoData((prev)=>{return {...prev,email:e.target.value}});}} onBlur={(e)=>_vli(e)} check='email' minLen='10' maxLength='64'/>
									<label>Email</label>
								</div>
							</div>
							<div className='col'>	
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="phone" value={personalInfoData.phone}  placeholder="Enter mobile no" onChange={e=>{setPersonalInfoData((prev)=>{return {...prev,phone:e.target.value}});}} onBlur={(e)=>_vli(e)} check='digit' minLen='10' maxLength='10'/>
									<label>Mobile No</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="password" value={personalInfoData.password}  placeholder="Enter password" onChange={e=>{setPersonalInfoData((prev)=>{return {...prev,password:e.target.value}});}} onBlur={(e)=>_vli(e)} check='password' minLen='8' maxLength='64'/>
									<label>Password</label>
								</div>
							</div>
							<div className='col'>	
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="cpassword" value={personalInfoData.cpassword}  placeholder="Enter confirm password" onChange={e=>{console.log(e);setPersonalInfoData((prev)=>{return {...prev,cpassword:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='8' maxLength='64'/>
									<label>Confirm Password</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>	
								<div className="text-end mb-3 mt-3">
									<button className='btn btn-secondary px-4 py-2'
									onClick={(e)=>{
										personalInfoData.dob=document.getElementById("dob").value;
										_vlai();
										let redBoxes=$(".form-control-error");
										if(redBoxes && redBoxes.length===0)
											modalObject.yesNo("Sure you want to create new user?",submitForm);
									}}
									>Create</button>
								</div>
							</div>
						</div>
						
					</div>
					
					
	</div>
	
	</>

);
};
export default JComponent;